export enum WebsitePublicPageType {
  Login = 'login',
  Register = 'register',
  RegisterConfirm = 'register-confirm',
  TwoFactorAuth = '2fa',
  ForgotPassword = 'restore-password',
  ResetPassword = 'reset-password',
  CreatePassword = 'create-password',
  ThankYou = 'thank-you',
  NotFound = 'not-found',
  InternalServerError = 'internal-server-error',
}
